import * as types from "./actionType";
import axios from "axios";

function fetchingLabelsAndPlaceholder(payload) {
  return {
    type: types.FETCH_LABELS_AND_PLACEHOLDER,
    payload,
  };
}

function fetchingLabelsAndPlaceholderSuccess(payload) {
  return {
    type: types.FETCH_LABELS_AND_PLACEHOLDER_SUCCESS,
    payload,
  };
}

function fetchingLabelsAndPlaceholderFailed(payload) {
  return {
    type: types.FETCH_LABELS_AND_PLACEHOLDER_FAILED,
    payload,
  };
}
//****** UserListing ********//

export const fetchLabelsAndPlaceholder = (payload) => async (dispatch) => {
  let mode = window.localStorage.getItem("lang") || "default";
  let data = payload[mode].config;
  dispatch(fetchingLabelsAndPlaceholder());
  axios
    .get(data.content)
    .then((response) => {
      if (response.status === 200) {
        dispatch(fetchingLabelsAndPlaceholderSuccess(response.data));
      } else {
        dispatch(fetchingLabelsAndPlaceholderFailed(response.data));
      }
    })
    .catch((error) => {});
};
